import React from 'react';
import { ArrowLeft } from 'lucide-react';
import MyRequestsView from '../views/MyRequestsView';
import useSupabase from '../../hooks/useSupabase';

/**
 * OnLoan Page - now reuses the MyRequestsView layout for reservations.
 */
function OnLoan({ onBack, userProfile }) {
  const { fetchReservations, updateReservationStatus } = useSupabase();

  return (
    <div className="fixed inset-0 bg-gray-50 z-[200]">
      <div className="h-full overflow-y-auto">
        {/* Header */}
        <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-4 py-4">
              <button
                onClick={onBack}
                className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
                <span className="text-sm font-medium">Back to Search</span>
              </button>
            </div>
          </div>
        </div>

        <div className="px-4 sm:px-6 lg:px-8 py-8">
          <MyRequestsView
            currentUser={userProfile}
            fetchReservations={fetchReservations}
            updateReservationStatus={updateReservationStatus}
            props={[]}
          />
        </div>
      </div>
    </div>
  );
}

export default OnLoan;
